import { RatingPromo } from 'components/page/PhotoRating/PhotoRating.constants'
import { findRandomItem } from 'functions/array'

export const isLikeCase = (likeCounter: number) =>
  likeCounter === 1 || (likeCounter !== 0 && likeCounter % 10 === 0)

export const getAvailablePromoTypes = (
  featuredPhotosActive: boolean | null,
  advEnabled: boolean,
  directAdFox: string[]
) => {
  return createAvailableTypes(
    featuredPhotosActive,
    advEnabled && directAdFox.includes('rating_swipe')
  )
}

export const createAvailableTypes = (
  featuredPhotosActive: boolean | null,
  advEnabled: boolean
): RatingPromo[] => {
  const result: RatingPromo[] = []
  if (!featuredPhotosActive) {
    result.push(RatingPromo.featured)
  }
  if (advEnabled) {
    result.push(RatingPromo.banner)
  }
  return result
}

export const selectPromoType = (
  promoTypes: RatingPromo[],
  lastShownPromoType: RatingPromo | null
): RatingPromo | null => {
  if (lastShownPromoType && promoTypes.length > 1) {
    return (
      promoTypes.find((promoType) => promoType !== lastShownPromoType) ||
      promoTypes[0]
    )
  }

  return findRandomItem(promoTypes) || null
}
